import { LAYOUT_FEATURE_KEY, LayoutState } from '../reducers/layout.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getLayoutState = createFeatureSelector<LayoutState>(LAYOUT_FEATURE_KEY);
export const selectBackground = createSelector(getLayoutState, ({ showBackgroundImage }) => showBackgroundImage);
